module.exports = __webpack_public_path__ + "img/17.ca1263d0.png";